import { Component } from '@angular/core';
import { ToastService } from 'app/services/toast.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  standalone: false
})
export class ToastContainerComponent {

  constructor(public toastService: ToastService) {}

}
